module.exports = __webpack_public_path__ + "img/green-ball.3d6c1d2f.svg";